import {
  AcUnitRounded,
  AccountCircleRounded,
  CheckCircle,
  ComputerOutlined,
  DehazeSharp,
  GppGood,
  MobileScreenShareOutlined,
  WebAssetOffOutlined,
  WebStories,
  Close,
  WhatsApp,
  Email,
  LocationOn,
  Phone,
  Star,
  ArrowForward,
  Security,
  Speed,
  SupportAgent,
  Diamond,
  Rocket,
  TrendingUp,
  WorkspacePremium,
  FlashOn,
  Psychology,
  CloudQueue,
} from "@mui/icons-material";

import { React, useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";

const backgroundImageUrl = 'url("/images/bgimage.jpg")';

function Home() {
  const [isclick, setisclick] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [hoveredNav, setHoveredNav] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggle = () => {
    setisclick(!isclick);
  };

  const closeMenu = () => {
    setisclick(false);
  };

  const navItems = [
    { name: "HOME", target: "targethome", icon: "🏠" },
    { name: "SERVICES", target: "targetDiv", icon: "⚡" },
    { name: "PRICING", target: "pricing", icon: "💰" },
    { name: "CLIENTS", target: "clients", icon: "👥" },
    { name: "DEMO", target: "softwareguid", icon: "🎬" },
  ];

  return (
    <div id="targethome" className="overflow-x-hidden">
      {/* Modern Animated Navbar */}
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? "bg-gradient-to-r from-gray-900/95 via-purple-900/95 to-gray-900/95 backdrop-blur-xl shadow-2xl py-2"
            : "bg-gradient-to-r from-gray-900 via-purple-900 to-gray-900 py-4"
        }`}
      >
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex justify-between items-center">
            {/* Animated Logo */}
            <div className="flex items-center gap-2 group cursor-pointer">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl blur-lg opacity-75 group-hover:opacity-100 transition-opacity"></div>
                <img
                  className="md:h-[60px] h-[45px] rounded-xl object-contain relative transform transition-all duration-500 group-hover:scale-110"
                  src="./images/logo.png"
                  alt="Logo"
                />
              </div>
              <div className="hidden md:block">
                <h1 className="text-white font-bold text-xl bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Developing
                </h1>
                <p className="text-xs text-gray-300">Desk Solutions</p>
              </div>
            </div>

            {/* Desktop Navigation with Modern Effects */}
            <div className="hidden md:flex items-center space-x-1">
              <ul className="flex space-x-1">
                {navItems.map((item, idx) => (
                  <li key={item.name}>
                    <ScrollLink
                      className={`relative px-5 py-2 rounded-full font-medium cursor-pointer transition-all duration-300 flex items-center gap-2 overflow-hidden group ${
                        activeSection === item.name
                          ? "text-white bg-gradient-to-r from-purple-500 to-pink-500 shadow-lg shadow-purple-500/30"
                          : "text-gray-300 hover:text-white"
                      }`}
                      to={item.target}
                      smooth={true}
                      duration={500}
                      spy={true}
                      activeClass="active-nav"
                      onSetActive={() => setActiveSection(item.name)}
                      onMouseEnter={() => setHoveredNav(idx)}
                      onMouseLeave={() => setHoveredNav(null)}
                    >
                      <span className="relative z-10 flex items-center gap-2">
                        <span className="text-lg">{item.icon}</span>
                        {item.name}
                      </span>
                      {!activeSection === item.name && (
                        <span className={`absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full transform transition-all duration-500 ${
                          hoveredNav === idx ? "scale-100 opacity-100" : "scale-0 opacity-0"
                        }`}></span>
                      )}
                    </ScrollLink>
                  </li>
                ))}
              </ul>
              
              {/* Animated WhatsApp Button */}
              <a href="https://wa.link/218fqg" target="_blank" rel="noopener noreferrer">
                <button className="relative ml-4 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl group overflow-hidden">
                  <span className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
                  <span className="relative flex items-center gap-2">
                    <WhatsApp className="animate-pulse" size={20} />
                    WhatsApp
                  </span>
                </button>
              </a>
            </div>

            {/* Mobile Menu Button with Animation */}
            <button
              className="md:hidden relative w-10 h-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              onClick={handleToggle}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                {isclick ? <Close className="text-white" size={24} /> : <DehazeSharp className="text-white" size={24} />}
              </div>
            </button>
          </div>

          {/* Modern Mobile Menu */}
          <div
            className={`md:hidden fixed inset-0 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 z-40 transition-all duration-500 ease-in-out ${
              isclick ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
            style={{ top: "70px" }}
          >
            <div className="flex flex-col items-center justify-center min-h-[80vh] space-y-6">
              {navItems.map((item, idx) => (
                <ScrollLink
                  key={item.name}
                  className="group relative overflow-hidden px-8 py-4 rounded-full text-white text-xl font-semibold cursor-pointer transition-all duration-300 hover:scale-110"
                  to={item.target}
                  smooth={true}
                  duration={500}
                  onClick={closeMenu}
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
                  <span className="relative flex items-center gap-3">
                    <span className="text-2xl">{item.icon}</span>
                    {item.name}
                  </span>
                </ScrollLink>
              ))}
              <a href="https://wa.link/218fqg" target="_blank" rel="noopener noreferrer" className="w-full max-w-[200px]">
                <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold px-6 py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center gap-2">
                  <WhatsApp size={24} />
                  WhatsApp
                </button>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section with Particles Effect */}
      <main className="pt-20 md:pt-24">
        <div
          className="relative min-h-[90vh] flex items-center overflow-hidden"
          style={{
            backgroundImage: backgroundImageUrl,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
          }}
        >
          {/* Animated Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-purple-900/50 to-black/80"></div>
          
          {/* Floating Elements */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-20 left-10 animate-float">
              <Diamond className="text-purple-400/30 text-6xl" />
            </div>
            <div className="absolute bottom-20 right-10 animate-float-delayed">
              <Rocket className="text-pink-400/30 text-6xl" />
            </div>
            <div className="absolute top-1/2 left-1/4 animate-pulse-slow">
              <CloudQueue className="text-blue-400/20 text-8xl" />
            </div>
          </div>
          
          <div className="container mx-auto px-4 md:px-8 relative z-10">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Video Section */}
              <div className="transform transition-all duration-700 hover:scale-105 animate-fade-in-up">
                <div className="relative group">
                  <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur-xl opacity-75 group-hover:opacity-100 transition duration-1000"></div>
                  <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-2 shadow-2xl">
                    <iframe
                      className="w-full rounded-xl aspect-video"
                      src="https://www.youtube.com/embed/2P7TAqLMLZ4?si=32_9vDWfFsZjLEkl&autoplay=0&rel=0"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="text-white space-y-6 animate-fade-in-right">
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                  <FlashOn className="text-yellow-400 animate-pulse" />
                  <span className="text-sm font-semibold">AI-Powered Solutions</span>
                </div>
                
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
                  Automate Your
                  <span className="block bg-gradient-to-r from-purple-400 via-pink-400 to-yellow-400 bg-clip-text text-transparent animate-gradient">
                    Business Success
                  </span>
                </h1>
                
                <p className="text-xl text-gray-200 leading-relaxed">
                  Transform your operations with cutting-edge software solutions that drive growth, efficiency, and innovation.
                </p>
                
                <div className="flex flex-wrap gap-6 text-lg">
                  <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                    <Phone className="text-green-400" /> +92 327-6558052
                  </div>
                  <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                    <WhatsApp className="text-green-400" /> +92 327-6558052
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-5 pt-6">
                  <button className="group relative bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl overflow-hidden">
                    <span className="relative z-10 flex items-center gap-2">
                      Watch Demo <ArrowForward className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </button>
                  <button className="group relative bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl overflow-hidden">
                    <span className="relative z-10 flex items-center gap-2">
                      Book Software <WorkspacePremium className="group-hover:rotate-12 transition-transform" />
                    </span>
                  </button>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 pt-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-purple-400">100+</div>
                    <div className="text-sm text-gray-300">Happy Clients</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-pink-400">50+</div>
                    <div className="text-sm text-gray-300">Projects</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-400">24/7</div>
                    <div className="text-sm text-gray-300">Support</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Services Section with Cards */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white" id="targetDiv">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full px-4 py-2 mb-4">
              <Rocket className="text-purple-600" />
              <span className="text-purple-600 font-semibold">What We Offer</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Premium <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Services</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
            <p className="text-gray-600 mt-6 max-w-2xl mx-auto text-lg">
              Comprehensive solutions tailored to transform your business operations
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <WebStories className="text-4xl" />,
                title: "Website Development",
                description: "Stunning, responsive websites that captivate your audience and drive conversions.",
                gradient: "from-blue-500 to-cyan-500",
                stats: "50+ Websites"
              },
              {
                icon: <ComputerOutlined className="text-4xl" />,
                title: "Software Development",
                description: "Custom POS and business software with 24/7 maintenance and support.",
                gradient: "from-purple-500 to-pink-500",
                stats: "100% Customizable"
              },
              {
                icon: <MobileScreenShareOutlined className="text-4xl" />,
                title: "Mobile Applications",
                description: "Native iOS & Android apps for seamless customer and staff experiences.",
                gradient: "from-green-500 to-teal-500",
                stats: "Real-time Sync"
              },
              {
                icon: <WebAssetOffOutlined className="text-4xl" />,
                title: "E-Commerce Solutions",
                description: "Fully automated online stores integrated with your POS system.",
                gradient: "from-orange-500 to-red-500",
                stats: "24/7 Online"
              }
            ].map((service, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 cursor-pointer overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-gray-50 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className={`bg-gradient-to-r ${service.gradient} w-20 h-20 rounded-2xl flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-all duration-500 shadow-lg`}>
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-purple-600 bg-purple-50 px-3 py-1 rounded-full">{service.stats}</span>
                  <button className="text-purple-600 font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Learn More <ArrowForward size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section with Modern Cards */}
      <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800" id="pricing">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
              <TrendingUp className="text-yellow-400" />
              <span className="text-white font-semibold">Pricing Plans</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Flexible <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Pricing</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
            <p className="text-gray-300 mt-6 max-w-2xl mx-auto text-lg">
              Choose the perfect plan that fits your business needs
            </p>
          </div>

          <div className="grid lg:grid-cols-5 gap-8">
            {/* Starter Pack */}
            <div className="lg:col-span-2 bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl p-8 text-white transform transition-all duration-500 hover:scale-105 shadow-2xl relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-bl-full"></div>
              <div className="relative">
                <h3 className="text-3xl font-bold mb-2">Starter Pack</h3>
                <div className="text-4xl font-bold mb-6">PKR 3,000 <span className="text-lg font-normal text-gray-400">/month</span></div>
                <div className="space-y-3">
                  {["POS System", "Menu Management", "Online Mode", "Standard Reports", "03 Users Included", "02 Training Sessions"].map((feature, i) => (
                    <div key={i} className="flex items-center gap-3 group-hover:translate-x-1 transition-transform">
                      <CheckCircle className="text-green-400 text-sm" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-8 bg-gradient-to-r from-yellow-400 to-orange-500 p-5 rounded-xl text-center transform transition-all duration-300 hover:scale-105 cursor-pointer">
                  <p className="font-bold text-gray-900 text-lg">🎉 Limited Time Offer!</p>
                  <p className="text-sm text-gray-900">Save 20% on annual plan</p>
                </div>
              </div>
            </div>

            {/* Add-ons with Hover Effects */}
            <div className="lg:col-span-3 space-y-4">
              {[
                { title: "Inventory Management", price: "PKR 3,000/Month", features: ["Inventory Tracking", "Stock Management", "Auto Reorder"] },
                { title: "Business Intelligence", price: "PKR 8,000/Month", features: ["Advanced Analytics", "Custom Reports", "Predictive Insights"] },
                { title: "Financial Management", price: "PKR 2,000/Month", features: ["Chart of Accounts", "Financial Reporting", "Tax Management"] },
                { title: "Guest Engagement", price: "PKR 4,000/Month", features: ["CRM System", "Loyalty Program", "Feedback Collection"] },
                { title: "Production Management", price: "PKR 2,000/Month", features: ["Production Planning", "Quality Control", "Supply Chain"] }
              ].map((item, idx) => (
                <div key={idx} className="group bg-white rounded-2xl p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-x-1 cursor-pointer">
                  <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-purple-600 transition-colors">{item.title}</h4>
                      <div className="flex flex-wrap gap-3">
                        {item.features.map((feature, i) => (
                          <span key={i} className="flex items-center gap-1 text-sm text-gray-600 bg-gray-50 px-3 py-1 rounded-full">
                            <CheckCircle className="text-green-500 text-xs" /> {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-purple-600 group-hover:scale-110 transition-transform">{item.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section with Enhanced Design */}
      <section className="py-24 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50" id="clients">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full px-4 py-2 mb-4">
              <Star className="text-yellow-500" />
              <span className="text-purple-600 font-semibold">Testimonials</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              What Our <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Clients Say</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { name: "Vital Distributers", role: "Wholesale Distributers", stat: "24%", label: "Cost Reduction", desc: "Revolutionized our operations with impressive expense reduction.", rating: 5, image: "🏢" },
              { name: "Surgical Indus", role: "Operations Manager", stat: "54%", label: "Productivity Boost", desc: "Like having a magician in the kitchen! Outstanding results.", rating: 5, image: "🏥" },
              { name: "Book Shops", role: "CEO", stat: "60%", label: "Revenue Growth", desc: "Essential asset for our business growth. Highly recommended!", rating: 5, image: "📚" }
            ].map((testimonial, idx) => (
              <div key={idx} className="group bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-gradient-to-r from-purple-400 to-pink-500 rounded-full p-4 text-3xl shadow-lg group-hover:scale-110 transition-transform">
                    {testimonial.image}
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-800">{testimonial.name}</h4>
                    <p className="text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
                <div className="flex gap-1 text-yellow-400 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="fill-current" />)}
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">{testimonial.desc}</p>
                <div className="flex justify-between items-center pt-4 border-t-2 border-gray-100">
                  <AcUnitRounded className="text-purple-400 text-3xl animate-pulse" />
                  <div className="text-right">
                    <span className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">{testimonial.stat}</span>
                    <p className="text-sm text-gray-500">{testimonial.label}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-24 bg-white" id="softwareguid">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full px-4 py-2 mb-4">
              <Rocket className="text-purple-600" />
              <span className="text-purple-600 font-semibold">Success Stories</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Recent <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Projects</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <h3 className="text-2xl font-bold text-center text-gray-800 mb-6">🚀 E-Commerce Projects</h3>
              <div className="space-y-3">
                {["afzalhardware.com", "behgalsports.com", "poshinds.com"].map((url, i) => (
                  <a key={i} href={`https://${url}`} target="_blank" rel="noopener noreferrer" 
                     className="block text-center text-purple-600 hover:text-purple-800 py-3 rounded-lg hover:bg-purple-50 transition-all transform hover:translate-x-2">
                    {url} →
                  </a>
                ))}
              </div>
            </div>

            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <h3 className="text-2xl font-bold text-center text-gray-800 mb-6">💻 Deployed Software</h3>
              <div className="space-y-2">
                {[
                  "Punjab Restaurant Software POS",
                  "Mrzgadgets Mobile Shop (Canada)",
                  "Hassanbook Depo Distributers",
                  "Salmantraders Distributers",
                  "Roshan Pk Cement Distributers"
                ].map((project, i) => (
                  <p key={i} className="text-center text-gray-700 py-2 hover:text-purple-600 transition-colors cursor-pointer">{project}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full px-4 py-2 mb-4">
              <Psychology className="text-purple-600" />
              <span className="text-purple-600 font-semibold">Learn & Grow</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Software <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Guide</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
            <p className="text-gray-600 mt-6 max-w-2xl mx-auto text-lg">Watch our comprehensive tutorial videos</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { title: "📦 How to Add Products", videoId: "2P7TAqLMLZ4" },
              { title: "👥 Register User Accounts", videoId: "QmE7qA60Dfc" },
              { title: "💰 Receiving From Customers", videoId: "X82QuURLPdE" }
            ].map((video, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-4">
                  <h3 className="text-white font-semibold text-lg text-center">{video.title}</h3>
                </div>
                <div className="p-4">
                  <iframe
                    className="w-full aspect-video rounded-lg"
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Diamond className="text-purple-400" />
                <span className="text-sm">Who We Are</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold">
                About <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Us</span>
              </h2>
              <p className="text-gray-300 leading-relaxed text-lg">
                We are a team of passionate developers and designers dedicated to transforming businesses through innovative software solutions. With over 5 years of experience, we've helped 100+ businesses achieve their digital goals.
              </p>
              <div className="flex gap-4 pt-4">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                  <Security className="text-blue-400" /> Secure
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                  <Speed className="text-green-400" /> Fast
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                  <SupportAgent className="text-purple-400" /> 24/7
                </div>
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3 group hover:translate-x-2 transition-transform">
                  <LocationOn className="text-purple-400 mt-1" />
                  <div>
                    <p className="font-semibold">Location</p>
                    <p className="text-gray-300">Sialkot, Pakistan</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 group hover:translate-x-2 transition-transform">
                  <Email className="text-purple-400 mt-1" />
                  <div>
                    <p className="font-semibold">Email</p>
                    <p className="text-gray-300">developingdesk@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 group hover:translate-x-2 transition-transform">
                  <Phone className="text-purple-400 mt-1" />
                  <div>
                    <p className="font-semibold">Phone</p>
                    <p className="text-gray-300">+92 327-6558052</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <p>&copy; 2024 Developing Desk. All rights reserved.</p>
          <p className="text-sm text-gray-400 mt-2">Empowering businesses through innovative software solutions</p>
        </div>
      </footer>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(1.05); }
        }
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in-right {
          from { opacity: 0; transform: translateX(-30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-float { animation: float 3s ease-in-out infinite; }
        .animate-float-delayed { animation: float-delayed 4s ease-in-out infinite; }
        .animate-pulse-slow { animation: pulse-slow 3s ease-in-out infinite; }
        .animate-fade-in-up { animation: fade-in-up 0.8s ease-out; }
        .animate-fade-in-right { animation: fade-in-right 0.8s ease-out; }
        .animate-gradient { background-size: 200% 200%; animation: gradient 3s ease infinite; }
      `}</style>
    </div>
  );
}

export default Home;